// TODO: Dynamic StatusTag` cell when endpoint is ready

import { TableCell } from '@mui/material';
import { formatDate } from '../utils/date';
import { formatNumber } from '../utils/number';
import { HeaderCellContent, TableCellContent } from './styled';

//import {
//  TableCell,
//  TableCell,
//  TableCellSubContent,
//} from '../Table/styled';

//import { formatDate } from '../utils/date';
//import { formatNumber } from '../utils/number';

type Column = {
  accessor: string;
  header: string;
  type?: 'date' | 'date-time' | 'percentage' | 'amount' | 'transaction-summary';
  wide?: boolean;
  format?: string[];
};

function getTableColumns(columns: Column[]) {
  return columns.map(({ accessor, header, type, wide, format }: Column) => {
    switch (type) {
      case 'amount':
        return {
          accessor,
          Header: () => <HeaderCellContent>{header}</HeaderCellContent>,
          Cell: (row: any) => (
            <TableCellContent>
              {formatNumber({ number: row.value.amount / 100 })}
            </TableCellContent>
          ),
        };
      case 'percentage':
        return {
          accessor,
          Header: () => <TableCell align='right'>{header}</TableCell>,
          Cell: (row: any) => (
            <TableCell align='right'>
              {/*{formatNumber({
                style: 'percent',
                number: row.value / 100,
                minimumFractionDigits: 0,
              })}*/}
            </TableCell>
          ),
        };
      case 'date-time':
        return {
          accessor,
          Header: () => <HeaderCellContent>{header}</HeaderCellContent>,
          Cell: (row: any) => {
            const { date, time } = formatDate(row.value);
            return (
              <TableCellContent>
                {date} {time}
              </TableCellContent>
            );
          },
        };
      case 'date':
        return {
          accessor,
          Header: () => <HeaderCellContent>{header}</HeaderCellContent>,
          Cell: (row: any) => {
            const { date } = formatDate(row.value);
            return <TableCellContent>{date}</TableCellContent>;
          },
        };
      case 'transaction-summary':
        return {
          accessor,
          Header: () => <HeaderCellContent>{header}</HeaderCellContent>,
          Cell: (row: any) => {
            return (
              <TableCellContent data-wide={wide}>{row.value}</TableCellContent>
            );
          },
        };
      default:
        return {
          accessor,
          Header: () => <HeaderCellContent>{header}</HeaderCellContent>,
          Cell: (row: any) => {
            return (
              <TableCellContent data-wide={wide}>{row.value}</TableCellContent>
            );
          },
        };
    }
  });
}

export { getTableColumns };
